import { render } from "./ContentBasedSuggestionsSideBar.vue?vue&type=template&id=b346ec92&scoped=true"
import script from "./ContentBasedSuggestionsSideBar.vue?vue&type=script&lang=js"
export * from "./ContentBasedSuggestionsSideBar.vue?vue&type=script&lang=js"

import "./ContentBasedSuggestionsSideBar.vue?vue&type=style&index=0&id=b346ec92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b346ec92"]])

export default __exports__